module.exports = __webpack_public_path__ + "img/defkf5.f65f26f1.png";